import { page, content } from './index.module.scss';
import CardList from '../components/card-list/CardList';
import Layout from '../components/layout';
import NewsletterSubscription from '../components/NewsletterSubscription';
import { useStaticQuery, graphql } from 'gatsby';

const Index = () => {
  const {
    wpPage: { content: pageContent },
  } = useStaticQuery(graphql`
    query SEOPageContent {
      wpPage(slug: { eq: "seo" }) {
        content
      }
    }
  `);

  return (
    <Layout>
      <div className={page}>
        <main>
          <div className={content} dangerouslySetInnerHTML={{ __html: pageContent }}></div>
          <CardList />
        </main>
      </div>
      <NewsletterSubscription />
    </Layout>
  );
};

export default Index;
